import { computed, makeObservable } from 'mobx'

import hasFeature from 'modules/core/lib/hasFeature'

import hasRegularAccess from 'modules/employees/lib/hasRegularAccess'
import type Employee from 'modules/employees/store/models/Employee'

class EmployeePolicy {
  employee: Employee
  isCurrent: boolean

  constructor(employee: Employee, isCurrent: boolean) {
    makeObservable(this, {
      timeOffRead: computed,
      profileRead: computed,
      tasksRead: computed,
      customTablesRead: computed,
      trainingsCustomTableRead: computed,
      competenciesCustomTableRead: computed,
      growthPlansCustomTableRead: computed,
      _isSupervised: computed,
    })
    this.employee = employee
    this.isCurrent = isCurrent
  }

  get timeOffRead(): boolean {
    return this.employee.policy.can('readLeaves')
  }

  get profileRead(): boolean {
    if (!hasFeature('strict_employee_visibility')) return true

    return this.isCurrent || this._isSupervised || this.timeOffRead
  }

  get tasksRead(): boolean {
    return this.isCurrent || this.employee.policy.can('manageTasks')
  }

  get customTablesRead(): boolean {
    return (
      hasFeature('employees_custom_tables') &&
      (hasFeature('always_show_custom_table') ||
        hasRegularAccess(this.employee.attributes.has_regular_access))
    )
  }

  get trainingsCustomTableRead(): boolean {
    return hasFeature('trainings_custom_table')
  }

  get competenciesCustomTableRead(): boolean {
    return hasFeature('competencies_custom_table')
  }

  get growthPlansCustomTableRead(): boolean {
    return hasFeature('growth_plans_custom_table')
  }

  /**
   * @deprecated
   */
  get _isSupervised(): boolean {
    return this.employee.isSupervisedByCurrent()
  }
}

export default EmployeePolicy
